import React from "react";

import { Trans, withTranslation } from "react-i18next";
import i18next from "i18next";

import {
  OverlayToaster,
  Popover,
  PopoverInteractionKind,
  Checkbox,
  Position,
  Button,
  FileInput,
  Tag,
  Classes,
  InputGroup,
  FormGroup,
  Intent,
  Dialog,
  Callout,
  NumericInput,
  HTMLSelect,
  DialogFooter,
  ButtonGroup,
  DialogBody,
  Card,
} from "@blueprintjs/core";
import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2,
  RenderMode,
} from "@blueprintjs/table";
import { DateInput3 } from "@blueprintjs/datetime2";

import {
  authenticatedGetFetch,
  authenticatedPatchFetch,
  authenticatedPostFetchWithResult,
} from "../../utils/AuthenticatedFetch";
import Title from "../Structure/logo";
import { DayPicker } from "react-day-picker";
import { getSetting } from "../Settings/InstallationSettings";
import { cachedGroups } from "../Supervision/SupervisionMenu";

const _localeUtils = DayPicker.LocaleUtils;

const Type_dbList = 1;
const Type_newList = 2;

/*
interface  PermCode {
    group: number[];
    codeMinLength: number;
    codeMaxLength: number;
  }
*/

class AccessCode extends React.Component {
  constructor(props) {
    super(props);

    this.toasterRef = React.createRef(null);
    const endDate = new Date();
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setMonth(endDate.getMonth() + 1);
    const startDate = new Date();
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);

    const permCode = localStorage.getItem("perm_code");
    const permCodeObj = JSON.parse(permCode);

    const groups = cachedGroups();

    this.state = {
      permCode: permCodeObj,
      codesList: [],
      newCodesList: [],
      groups: groups,
      importGroup: permCodeObj.group?.map((i) => {
        const group = Object.values(groups).find((g) => g.id === i);
        if (group) return { ...group, selected: true };
        else
          return {
            id: 0,
            label: "",
            selected: false,
            parks: [{ id: 0, name: "" }],
          };
      }),
      importStartDate: startDate,
      importEndDate: endDate,
      runningEdit: false,
      runningAdd: false,
      runningDelete: false,
      runningRandom: false,
      random_length: 0,
      random_value: 0,
      editCode_type: 0,
      editCode_index: 0,
      editCode_value: "",
      editCode_startDate: 0,
      editCode_endDate: 0,
      editCode_groups: [],
      dbListToDelete: [],
    };
  }

  addToDeleteList(rowIndex, state) {
    const list = [...this.state.dbListToDelete];
    const index = list.findIndex((i) => i === rowIndex);
    if (index === -1) list.push(rowIndex);
    else list.splice(index, 1);

    this.setState({ dbListToDelete: list });
  }

  removeSelection() {
    const data = [...this.state.codesList];
    this.state.dbListToDelete.forEach((i) => {
      data[i].deleted = true;
    });
    this.setState({ codesList: data, dbListToDelete: [] });
  }

  generateRandom() {
    const listRandomCode = [...this.state.newCodesList];
    const groups = this.state.importGroup.filter((g) => g.selected === true);
    const maxValue = Math.pow(10, this.state.random_length) - 1;
    for (
      let iter = 0;
      listRandomCode.length <
      this.state.newCodesList.length + Number(this.state.random_value);
      iter++
    ) {
      let value = Math.floor(Math.random() * maxValue);
      value = String(value).padStart(this.state.random_length, "0");
      const code = this.getCodeObj(value, groups);
      code.startDate = new Date(this.state.importStartDate);
      code.endDate = new Date(this.state.importEndDate);
      if (this.codeIsValid(code, -1, 0)) {
        listRandomCode.push(code);
      }

      if (iter === 2 * this.state.random_value) {
        console.log("break");
        break;
      }
    }
    this.setState({ newCodesList: listRandomCode });
    this.handleClose();
  }

  getGroupDefinition(groupId) {
    return Object.values(this.state.groups).find((g) => g.id === groupId);
  }

  componentDidMount() {
    /* if (
      !getSetting("enable code") ||
      !(
        localStorage.getItem("perm_financial") === "false" &&
        localStorage.getItem("perm_SPV") === "false" &&
        localStorage.getItem("perm_activity") === "false" &&
        localStorage.getItem("perm_code") !== undefined
      )
    ) {
      window.location.replace("ow/view/home");
    } else */ // TODO: display no permission error
    authenticatedGetFetch("/codes", (response) => {
      response.forEach((c) => {
        c.groups = c.groups.map((g) => {
          const group = this.getGroupDefinition(g.id);
          return { ...group, selected: true };
        });
      });
      this.setState({ codesList: response });
    });
  }

  updateStartDate(rowIndex, date) {
    const data = [...this.state.newCodesList];
    data[rowIndex].startDate = date;
    this.setState({ newCodesList: data });
  }
  updateEndDate(rowIndex, date) {
    const data = [...this.state.newCodesList];
    data[rowIndex].endDate = date;
    this.setState({ newCodesList: data });
  }
  updateKey(rowIndex, value) {
    const data = [...this.state.newCodesList];
    data[rowIndex].key = value.target.value;
    this.setState({ newCodesList: data });
  }

  getRowIntent(data) {
    let intent = "";
    if (data.deleted) intent = "danger";
    else if (data.updated) intent = "primary";
    return intent;
  }
  getCodesList() {
    return this.getCodesArray(this.state.codesList, Type_dbList);
  }

  getNewCodesList() {
    return this.getCodesArray(this.state.newCodesList, Type_newList);
  }

  showDbDelete(rowIndex, type) {
    const conf = {
      runningDelete: true,
      editCode_index: rowIndex,
      editCode_type: type,
    };
    if (type === Type_dbList)
      this.setState({
        ...conf,
        editCode_value: this.state.codesList[rowIndex].key,
      });
    else
      this.setState({
        ...conf,
        editCode_value: this.state.newCodesList[rowIndex].key,
      });
  }

  deleteKey() {
    if (this.state.editCode_type === Type_newList) {
      const data = [...this.state.newCodesList];
      data.splice(this.state.editCode_index, 1);
      this.setState({ newCodesList: data, runningDelete: false });
    } else {
      const data = [...this.state.codesList];
      data[this.state.editCode_index].deleted = true;
      this.setState({ codesList: data, runningDelete: false });
    }
  }

  editKey(rowIndex, type) {
    let data;
    if (type === Type_dbList) {
      data = this.state.codesList[rowIndex];
    } else {
      data = this.state.newCodesList[rowIndex];
    }
    this.setState({
      runningEdit: true,
      editCode_type: type,
      editCode_index: rowIndex,
      editCode_value: data.key,
      editCode_startDate: data.startDate,
      editCode_endDate: data.endDate,
      editCode_groups: data.groups.map((g) => {
        return {
          id: g.id,
          label: g.label,
          selected: g.selected,
        };
      }),
    });
  }

  loadContent(event) {
    let file = event.target.files[0];
    if (!file) return;

    const groupList = this.getSelectedGroupId();

    let fileReader = new FileReader();
    fileReader.onloadend = (evt) => {
      //Normalize content
      let importNewCodesList = [];
      const content = fileReader.result;
      if (content.includes("\n")) {
        const newContent = content.replace("\r", "");
        let codeLine = newContent.split("\n");
        for (let line in codeLine) {
          if (codeLine[line].includes(";")) {
            let code = codeLine[line].split(";");
            for (let iter = 0; iter < code.length; iter++) {
              if (code[iter].length > 0) importNewCodesList.push(code[iter]);
            }
          } else {
            if (codeLine[line].length > 0)
              importNewCodesList.push(codeLine[line]);
          }
        }
      } else {
        importNewCodesList = content.split(";");
      }
      //Check the code length
      const errorMessage = [];
      const newList = [];
      for (let index = 0; index < importNewCodesList.length; index++) {
        const codeObj = this.getCodeObj(
          importNewCodesList[index],
          this.state.importGroup.filter((g) => g.selected === true)
        );
        if (!this.codeIsValid(codeObj, -1)) {
          if (importNewCodesList[index].length > 0)
            errorMessage.push(importNewCodesList[index]);
        } else newList.push(parseInt(importNewCodesList[index], 10));
      }
      const list = [...this.state.newCodesList];

      this.setState({
        newCodesList: list.concat(
          newList.map((item) => {
            return {
              key: item,
              startDate: this.state.importStartDate,
              endDate: this.state.importEndDate,
              groups: groupList,
            };
          })
        ),
      });

      if (errorMessage.length > 0) {
        this.showMessageError(
          i18next.t(
            "the code shown in the below list has not a correct length"
          ) +
            ":" +
            errorMessage.join(", ")
        );
      }
    };
    fileReader.readAsText(file);
  }

  getCodeObj(code, groups) {
    return { key: code, groups: groups };
  }

  codeExistInTheList(list, listType, codeObj, index, type) {
    if (index === -1 || type !== listType) {
      // add
      const retIndex = list.findIndex((item) => {
        let groupMatch = false;
        item.groups.forEach((id) => {
          if (
            !groupMatch &&
            codeObj.groups.findIndex((g) => g.id === id.id) !== -1
          )
            groupMatch = true;
        });
        return item.key === codeObj.key && groupMatch;
      });
      return retIndex !== -1;
    } else {
      //Update : If it is not the same type => we manage it as adding
      const retIndex = list.findIndex((item, indexData) => {
        let groupMatch = false;
        item.groups.forEach((id) => {
          if (
            !groupMatch &&
            codeObj.groups.findIndex((g) => g.id === id.id) !== -1
          )
            groupMatch = true;
        });
        return item.key === codeObj.key && groupMatch && indexData !== index;
      });
      return retIndex !== -1;
    }
  }
  codeIsValid(code, editIndex, type) {
    //check if the code is conform
    try {
      const val = parseInt(code.key, 10);
      if (isNaN(val)) return false;
    } catch (error) {
      return false;
    }
    if (
      code.key.length === 0 ||
      code.key.length === 6 ||
      code.key.length < this.state.permCode.codeMinLength ||
      code.key.length > this.state.permCode.codeMaxLength
    )
      return false;

    return (
      !this.codeExistInTheList(
        this.state.newCodesList,
        Type_newList,
        code,
        editIndex,
        type
      ) &&
      !this.codeExistInTheList(
        this.state.codesList,
        Type_dbList,
        code,
        editIndex,
        type
      )
    );
    //return !this.codeExistInCourantList(code, editIndex, type) && !this.codeExistInNewList(code, editIndex, type);
  }

  handleClose() {
    if (
      this.state.runningDelete ||
      this.state.runningEdit ||
      this.state.runningAdd ||
      this.state.runningRandom
    )
      this.setState({
        runningEdit: false,
        runningDelete: false,
        runningAdd: false,
        runningRandom: false,
        editCode_index: 0,
        editCode_value: "",
        editCode_startDate: 0,
        editCode_endDate: 0,
        random_length: 0,
        random_value: 0,
      });
  }

  dbCodeHaveChanged() {
    let haveChange = false;
    this.state.codesList.forEach((c) => {
      if (c.deleted || c.updated) haveChange = true;
    });
    return haveChange;
  }
  saveDbCode() {
    this.setState({ loading: true }, async () => {
      const deletedList = this.state.codesList.filter((c) => c.deleted);
      let updatedList = this.state.codesList.filter((c) => c.updated);
      await (async () => {
        return new Promise((res, rej) => {
          authenticatedPatchFetch(
            "/code",
            {
              delete: deletedList,
              update: updatedList,
            },
            (statusCode, response) => {
              response.forEach((c) => {
                c.groups = c.groups.map((g) => {
                  const group = this.getGroupDefinition(g.id);
                  return { ...group, selected: true };
                });
              });
              this.setState({ codesList: response, loading: false });
              res();
            },
            (error) => {
              console.log("error", error.message);
              rej(error.message);
            }
          );
        });
      })();

      this.setState({ loading: false });
    });
  }

  updateCode() {
    if (this.state.runningEdit) {
      const codeObj = this.getCodeObj(
        this.state.editCode_value,
        this.state.editCode_groups
      );
      if (
        !this.codeIsValid(
          codeObj,
          this.state.editCode_index,
          this.state.editCode_type
        )
      )
        this.showMessageError(i18next.t("code is not valid"));
      else if (this.state.editCode_type === Type_dbList) {
        //Check if we add code by adding park
        const data = [...this.state.codesList];
        data[this.state.editCode_index].updated = true;
        data[this.state.editCode_index].key = this.state.editCode_value;
        data[this.state.editCode_index].startDate =
          this.state.editCode_startDate;
        data[this.state.editCode_index].endDate = this.state.editCode_endDate;
        data[this.state.editCode_index].groups = this.state.editCode_groups;
        this.setState({ codesList: data, loading: false });
      } else {
        const data = [...this.state.newCodesList];
        data[this.state.editCode_index].key = this.state.editCode_value;
        data[this.state.editCode_index].startDate =
          this.state.editCode_startDate;
        data[this.state.editCode_index].endDate = this.state.editCode_endDate;
        data[this.state.editCode_index].groups = this.state.editCode_groups;

        this.setState({ newCodesList: data, loading: false });
      }
      this.handleClose();
    } else {
      const data = [...this.state.newCodesList];
      data.push({
        key: this.state.editCode_value,
        startDate: this.state.editCode_startDate,
        endDate: this.state.editCode_endDate,
        groups: this.getSelectedGroupIdToAdd(),
      });

      this.setState({
        newCodesList: data,
        loading: false,
        runningAdd: false,
        editCode_value: "",
      });
    }
  }

  saveImportedList() {
    const newList = [];
    this.state.newCodesList.forEach((c) => {
      c.groups.forEach((g) => {
        if (g.selected) {
          newList.push({
            key: c.key,
            endDate: c.endDate,
            startDate: c.startDate,
            groups: [{ id: g.id }],
          });
        }
      });
    });
    authenticatedPostFetchWithResult(
      "/code",
      { codesList: newList },
      (statusCode, response) => {
        response.forEach((c) => {
          c.groups = c.groups.map((g) => {
            const group = this.getGroupDefinition(g.id);
            return { ...group, selected: true };
          });
        });
        this.setState({ codesList: response, newCodesList: [] });
      },
      (error) => {
        console.log(error);
        this.showMessageError(error.msg);
      }
    );
  }

  importActionIsValid() {
    let oneEnable = false;
    this.state.importGroup?.forEach((g) => {
      if (g.selected) oneEnable = true;
    });
    return oneEnable;
  }

  getSelectedGroupId() {
    let res = [];
    this.state.importGroup.forEach((g) => {
      if (g.selected) res.push({ id: g.id, label: g.label, selected: true });
    });
    return res;
  }

  getSelectedGroupIdToAdd() {
    let res = [];
    this.state.editCode_groups.forEach((g) => {
      if (g.selected) res.push({ id: g.id, label: g.label, selected: true });
    });
    return res;
  }

  importGroupIsValid(group) {
    let oneEnable = false;
    group?.forEach((g) => {
      if (g.selected) oneEnable = true;
    });
    if (!oneEnable)
      this.showMessageError(i18next.t("you must select at least one group"));
  }

  showMessageError(msg) {
    this.toasterRef.current.show({
      icon: "layout-grid",
      intent: "warning",
      isCloseButtonShown: true,
      timeout: 0,
      message: (
        <div>
          <b>
            <Trans>error during processing code</Trans>
          </b>
          <p>{msg}</p>
        </div>
      ),
    });
  }

  editModeGroupIsSelected(group) {
    const gp = this.state.editCode_groups.filter((g) => g.id === group.id);
    if (gp.length > 0) return gp[0].selected;
    else return false;
  }

  getUserGroupInfo() {
    return (
      <Callout title={<Trans>group information</Trans>}>
        {/* liste des parcs associée au droit de l'utilisateur courant */}
        <div key={"grp"} className="flexbox-left">
          {this.state.importGroup?.map((g) => (
            <Card key={"grp" + g.id}>
              <b>{g.label}</b>
              <p>
                <Trans>park</Trans>:
                {g.parks?.map((p) => (
                  <Tag key={"grp" + g.id + "_" + p.id}>{p.name}</Tag>
                ))}
              </p>
              <p>
                <Trans>devices</Trans>:
                {g.devices?.map((d) => (
                  <Tag key={"grp" + g.id + "_d" + d.id}>{d.name}</Tag>
                ))}
              </p>
            </Card>
          ))}
        </div>
        <p>
          <Trans>identification code</Trans>{" "}
          <Tag>{localStorage.getItem("userId").padStart(2, "0")}</Tag>
        </p>
      </Callout>
    );
  }

  getParkName(id) {
    let label = "";
    this.state.importGroup.forEach((g) => {
      g.parks.forEach((p) => {
        if (p.id === id) label = p.name;
      });
    });
    return label;
  }

  getCodesArray(data, type) {
    if (data.length === 0) return null;

    let column = [];
    if (type === Type_dbList) {
      column = [
        <Column
          id="dbValue"
          key="dbValue"
          cellRenderer={(rowIndex) => (
            <Cell intent={this.getRowIntent(data[rowIndex])}>
              {data[rowIndex]["key"]}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>value</Trans>} />
          )}
        />,
        <Column
          id="dbStartDate"
          key="dbStartDate"
          cellRenderer={(rowIndex) => (
            <Cell intent={this.getRowIntent(data[rowIndex])}>
              {new Date(data[rowIndex]["startDate"]).toLocaleDateString(
                i18next.language
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>start date</Trans>} />
          )}
        />,
        <Column
          id="dbEndDate"
          key="dbEndDate"
          cellRenderer={(rowIndex) => (
            <Cell intent={this.getRowIntent(data[rowIndex])}>
              {new Date(data[rowIndex]["endDate"]).toLocaleDateString(
                i18next.language
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>end date</Trans>} />
          )}
        />,
        <Column
          id="dbGroups"
          key="dbGroups"
          cellRenderer={(rowIndex) => (
            <Cell
              intent={this.getRowIntent(data[rowIndex])}
              key={"dbg" + rowIndex}
            >
              {data[rowIndex].groups
                .filter((f) => f.selected)
                .map((g) => (
                  <span key={"cel" + rowIndex}>
                    <Tag>{g.label}</Tag>{" "}
                  </span>
                ))}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>group name</Trans>} />
          )}
        />,
        <Column
          id="dbAction"
          key="dbAction"
          cellRenderer={(rowIndex) => (
            <Cell intent={this.getRowIntent(data[rowIndex])}>
              {!data[rowIndex].deleted && (
                <div className="flexbox-center">
                  <Tag
                    icon="trash"
                    interactive={true}
                    minimal={true}
                    onClick={() => this.showDbDelete(rowIndex, type)}
                  />

                  <Tag
                    icon="edit"
                    interactive={true}
                    minimal={true}
                    onClick={() => {
                      this.editKey(rowIndex, type);
                    }}
                  />
                </div>
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => <ColumnHeaderCell />}
        />,
        <Column
          id="dbRemove"
          key="dbRemove"
          cellRenderer={(rowIndex) => (
            <Cell intent={this.getRowIntent(data[rowIndex])}>
              {!data[rowIndex].deleted && (
                <div className="flexbox-center">
                  <Checkbox
                    checked={this.state.dbListToDelete.includes(rowIndex)}
                    onChange={(cb) =>
                      this.addToDeleteList(rowIndex, cb.target.checked)
                    }
                  />
                </div>
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>remove</Trans>} />
          )}
        />,
      ];
    } else {
      column = [
        <Column
          id="newListValue"
          key="newListValue"
          cellRenderer={(rowIndex) => <Cell>{data[rowIndex]["key"]}</Cell>}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>value</Trans>} />
          )}
        />,
        <Column
          id="newListStartDate"
          key="newListStartDate"
          cellRenderer={(rowIndex) => (
            <Cell>
              {new Date(data[rowIndex]["startDate"]).toLocaleDateString(
                i18next.language
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>start date</Trans>} />
          )}
        />,
        <Column
          id="newListEndDate"
          key="newListEndDate"
          cellRenderer={(rowIndex) => (
            <Cell>
              {new Date(data[rowIndex]["endDate"]).toLocaleDateString(
                i18next.language
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>end date</Trans>} />
          )}
        />,
        <Column
          id="newListGroupName"
          key="newListGroupName"
          cellRenderer={(rowIndex) => (
            <Cell>
              {data[rowIndex].groups
                .filter((f) => f.selected)
                .map((g) => (
                  <span key={"nlg" + g.id}>
                    <Tag>{g.label}</Tag>{" "}
                  </span>
                ))}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>group name</Trans>} />
          )}
        />,
        <Column
          id="newListAction"
          key="newListAction"
          cellRenderer={(rowIndex) => (
            <Cell>
              <div className="flexbox-center">
                <Tag
                  icon="trash"
                  interactive={true}
                  minimal={true}
                  onClick={() => this.showDbDelete(rowIndex, type)}
                />

                <Tag
                  icon="edit"
                  interactive={true}
                  minimal={true}
                  onClick={() => {
                    this.editKey(rowIndex, type);
                  }}
                />
              </div>
            </Cell>
          )}
          columnHeaderCellRenderer={() => <ColumnHeaderCell />}
        />,
      ];
    }

    return (
      <Table2
        key={Date.now()}
        renderMode={RenderMode.BATCH_ON_UPDATE}
        cellRendererDependencies={data}
        numRows={data.length}
        rowHeaderCellRenderer={(rowIndex) => (
          <RowHeaderCell index={rowIndex} name={data["id"]} />
        )}
      >
        {column}
      </Table2>
    );
  }

  render() {
    if (!getSetting("enable code"))
      return (
        <div className="component-body">
          <Callout intent="warning" />
          <Trans>you are not allowed to visualize element:</Trans>
          <br />
          <Trans>
            for any change of your permissions please contact an administrator
          </Trans>
        </div>
      );
    else
      return (
        <div className="component-body">
          {/* Random widget */}
          <Dialog
            isOpen={this.state.runningRandom}
            onClose={() => this.handleClose()}
            title={<Trans>random codes generation</Trans>}
          >
            <DialogBody>
              <FormGroup
                labelFor="access-code-input-random-size"
                label={<Trans>length</Trans>}
                inline={true}
              >
                <HTMLSelect
                  id="access-code-input-random-size"
                  options={Array.from(
                    {
                      length:
                        this.state.permCode.codeMaxLength -
                        this.state.permCode.codeMinLength +
                        1,
                    },
                    (value, index) => this.state.permCode.codeMinLength + index
                  ).filter((val) => val !== 6)}
                  onChange={(media) =>
                    this.setState({ random_length: media.target.value })
                  }
                />
              </FormGroup>
              <FormGroup
                labelFor="access-code-input-random"
                label={<Trans>quantity</Trans>}
                inline={true}
              >
                <NumericInput
                  id="access-code-input-random"
                  max={50}
                  value={this.state.random_value}
                  onValueChange={(value) =>
                    this.setState({
                      random_value: Math.max(0, Math.min(value, 50)),
                    })
                  }
                />
              </FormGroup>
            </DialogBody>
            <DialogFooter
              actions={
                <ButtonGroup>
                  <Button
                    icon="undo"
                    intent={Intent.DANGER}
                    disabled={this.state.loading}
                    onClick={() => this.handleClose()}
                  >
                    <Trans>cancel</Trans>
                  </Button>
                  <Button
                    icon="send-to"
                    disabled={
                      this.state.random_length === 0 ||
                      this.state.random_value === 0
                    }
                    loading={this.state.loading}
                    onClick={() => this.generateRandom()}
                  >
                    <Trans>generate</Trans>
                  </Button>
                </ButtonGroup>
              }
            />
          </Dialog>

          {/* Edit & Add message */}
          <Dialog
            isOpen={this.state.runningEdit || this.state.runningAdd}
            onClose={() => this.handleClose()}
            title={
              this.state.runningEdit ? (
                <Trans>edit code</Trans>
              ) : (
                <Trans>add code</Trans>
              )
            }
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup
                labelFor="access-code-input"
                label="Code"
                inline={true}
              >
                <InputGroup
                  id="access-code-input"
                  onChange={(ti) =>
                    this.setState({
                      editCode_value: ti.target.value.replace(/\D/g, ""),
                    })
                  }
                  value={this.state.editCode_value}
                  intent={
                    this.state.errPwdSpecial ||
                    this.state.errPwdLength ||
                    this.state.errPwdMissmatch
                      ? "danger"
                      : "normal"
                  }
                />
              </FormGroup>
              {this.state.runningEdit &&
                this.state.editCode_type !== Type_dbList && (
                  <FormGroup
                    label={
                      <Trans>
                        select the zone where the codes will be applied
                      </Trans>
                    }
                    inline={true}
                  >
                    {this.state.importGroup.map((group, index) => (
                      <Checkbox
                        key={"cbec" + group.id}
                        checked={this.editModeGroupIsSelected(group)}
                        label={group.label}
                        onChange={(cb) => {
                          const selecteGroup = this.state.importGroup[index];
                          const group = this.state.editCode_groups;
                          const theGroup = group.filter(
                            (g) => g.id === selecteGroup.id
                          );
                          if (theGroup.length > 0)
                            theGroup[0].selected = !theGroup[0].selected;
                          else {
                            group.push({
                              id: selecteGroup.id,
                              label: selecteGroup.label,
                              selected: true,
                            });
                          }
                          this.importGroupIsValid(group);
                          this.setState({ editCode_groups: group });
                        }}
                      />
                    ))}
                  </FormGroup>
                )}
              <div className="flexbox-left">
                <FormGroup
                  label={<Trans>start date:</Trans>}
                  labelFor="code_start_date"
                  inline={true}
                >
                  <DateInput3
                    id="code_start_date"
                    formatDate={(date) =>
                      date.toLocaleDateString(i18next.language)
                    }
                    highlightCurrentDay={true}
                    minDate={new Date()}
                    placeholder={new Date(
                      this.state.editCode_startDate
                    ).toLocaleDateString(i18next.language)}
                    onChange={(selectedDate) =>
                      this.setState({ editCode_startDate: selectedDate })
                    }
                    localeUtils={_localeUtils}
                    locale={i18next.language}
                  />
                </FormGroup>
                <FormGroup
                  label={<Trans>end date:</Trans>}
                  labelFor="code_end_date"
                  inline={true}
                >
                  <DateInput3
                    id="code_end_date"
                    formatDate={(date) =>
                      date.toLocaleDateString(i18next.language)
                    }
                    highlightCurrentDay={true}
                    minDate={new Date()}
                    placeholder={new Date(
                      this.state.editCode_endDate
                    ).toLocaleDateString(i18next.language)}
                    onChange={(selectedDate) =>
                      this.setState({ editCode_endDate: selectedDate })
                    }
                    localeUtils={_localeUtils}
                    locale={i18next.language}
                  />
                </FormGroup>
              </div>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  icon="undo"
                  intent={Intent.DANGER}
                  disabled={this.state.loading}
                  onClick={() => this.handleClose()}
                >
                  <Trans>cancel</Trans>
                </Button>
                <Button
                  icon="send-to"
                  loading={this.state.loading}
                  disabled={
                    !this.codeIsValid(
                      this.getCodeObj(
                        this.state.editCode_value,
                        this.state.runningEdit
                          ? this.state.editCode_groups
                          : this.state.importGroup.filter(
                              (g) => g.selected === true
                            )
                      ),
                      this.state.runningEdit ? this.state.editCode_index : -1,
                      this.state.editCode_type
                    )
                  }
                  onClick={() => this.updateCode()}
                >
                  <Trans>confirm</Trans>
                </Button>
              </div>
            </div>
          </Dialog>

          {/* Delete message */}
          <Dialog
            isOpen={this.state.runningDelete}
            onClose={() => this.handleClose()}
            title={<Trans>delete code</Trans>}
            icon="trash"
          >
            <DialogBody>
              <Trans>are you sure you want to delete the code</Trans>
              <Tag>{this.state.editCode_value}</Tag>?
            </DialogBody>
            <DialogFooter
              actions={
                <ButtonGroup>
                  <Button
                    icon="undo"
                    intent={Intent.DANGER}
                    disabled={this.state.loading}
                    onClick={() => this.handleClose()}
                  >
                    <Trans>cancel</Trans>
                  </Button>
                  <Button
                    icon="send-to"
                    loading={this.state.loading}
                    onClick={() => this.deleteKey()}
                  >
                    <Trans>confirm</Trans>
                  </Button>
                </ButtonGroup>
              }
            />
          </Dialog>

          <OverlayToaster
            ref={this.toasterRef}
            position={Position.BOTTOM_RIGHT}
            maxToasts={5}
          />

          <Callout intent="info">
            <Title text="access code management" />
            {this.getUserGroupInfo()}
            <br />
            <Callout
              title={
                <span>
                  <Trans>existing codes</Trans> ({this.state.codesList.length})
                </span>
              }
            >
              {this.getCodesList()}
              <div className="flexbox-right">
                <Button
                  icon="send-to"
                  loading={this.state.loading}
                  disabled={!this.dbCodeHaveChanged()}
                  onClick={() => this.saveDbCode()}
                >
                  <Trans>save changes</Trans>
                </Button>
              </div>

              <div className="flexbox-right">
                <Button
                  icon="trash"
                  loading={this.state.loading}
                  disabled={this.state.dbListToDelete.length === 0}
                  onClick={() => this.removeSelection()}
                >
                  <Trans>remove selection</Trans>
                </Button>
              </div>
            </Callout>
            <br />
            <Callout
              title={
                <span>
                  <Trans>add code</Trans> ({this.state.newCodesList.length})
                </span>
              }
            >
              <Callout intent="warning">
                <Trans>Code Rules</Trans>{" "}
                <b>
                  {this.state.permCode.codeMinLength} <Trans>and</Trans>{" "}
                  {this.state.permCode.codeMaxLength}
                </b>{" "}
                <Trans>characters</Trans>
              </Callout>

              <div>
                <FormGroup
                  label={<Trans>end date:</Trans>}
                  labelFor="code_start_date_batch"
                  inline={true}
                >
                  <DateInput3
                    id="code_start_date_batch"
                    formatDate={(date) => date.toLocaleString(i18next.language)}
                    highlightCurrentDay={true}
                    minDate={new Date()}
                    placeholder={new Date(
                      this.state.importStartDate
                    ).toLocaleDateString(i18next.language)}
                    onChange={(selectedDate) =>
                      this.setState({ importStartDate: selectedDate })
                    }
                    localeUtils={_localeUtils}
                    locale={i18next.language}
                  />
                </FormGroup>

                <FormGroup
                  label={<Trans>end date:</Trans>}
                  labelFor="code_end_date_batch"
                  inline={true}
                >
                  <DateInput3
                    id="code_end_date_batch"
                    formatDate={(date) =>
                      date.toLocaleDateString(i18next.language)
                    }
                    highlightCurrentDay={true}
                    minDate={new Date()}
                    placeholder={new Date(
                      this.state.importEndDate
                    ).toLocaleDateString(i18next.language)}
                    onChange={(selectedDate) =>
                      this.setState({ importEndDate: selectedDate })
                    }
                    localeUtils={_localeUtils}
                    locale={i18next.language}
                  />
                </FormGroup>
                <Popover
                  placement="auto"
                  interactionKind={PopoverInteractionKind.HOVER}
                  modifiers={{ arrow: { enabled: true } }}
                  content={
                    <div style={{ padding: "5px" }}>
                      {this.state.importGroup.map((group, index) => (
                        <Checkbox
                          key={"choice" + group.id}
                          checked={group.selected}
                          label={group.label}
                          onChange={(cb) => {
                            const group = this.state.importGroup;
                            group[index].selected = !group[index].selected;
                            this.importGroupIsValid(group);
                            this.setState({ importGroup: group });
                          }}
                        />
                      ))}
                    </div>
                  }
                >
                  <Button minimal={false} intent="success">
                    <Trans>
                      select the zone where the codes will be applied
                    </Trans>
                  </Button>
                </Popover>

                <FileInput
                  disabled={false}
                  text={i18next.t("Choose file...")}
                  buttonText={i18next.t("browse")}
                  onInputChange={(event) => {
                    this.loadContent(event);
                  }}
                />

                <Button
                  icon="add"
                  intent="primary"
                  disabled={!this.importActionIsValid()}
                  onClick={() => {
                    this.setState({
                      runningAdd: true,
                      editCode_endDate: this.state.importEndDate,
                      editCode_startDate: this.state.importStartDate,
                      editCode_groups: this.state.importGroup,
                    });
                  }}
                >
                  <Trans>add code</Trans>
                </Button>
                <Button
                  icon="add"
                  intent="warning"
                  onClick={() => this.setState({ runningRandom: true })}
                >
                  <Trans>random codes generation</Trans>
                </Button>
              </div>
              <br />
              {this.getNewCodesList()}
              <br />
              <div className="flexbox-right">
                <Button
                  icon="send-to"
                  loading={this.state.loading}
                  disabled={this.state.newCodesList.length === 0}
                  onClick={() => this.saveImportedList()}
                  intent="normal"
                >
                  <Trans>save code list</Trans>
                </Button>
              </div>
            </Callout>
          </Callout>
        </div>
      );
  }
}

export default withTranslation()(AccessCode);
